import { ActivityIcon, Store, Users } from "lucide-react";
import { Segment } from "../../../../components/segment";
import {
  COMMUNITY_IMPACT_MAP_KEY,
  LIVE_EVENTS_MAP_KEY,
  USER_DISTRIBUTIONS_MAP_KEY,
} from "../../commons/Constant";

type GeographicTabMenuProps = {
  value: string;
  onChange: (value: string) => void;
  canAccessCommunityImpact: boolean;
};

export function GeographicTabMenu({
  value,
  onChange,
  canAccessCommunityImpact,
}: GeographicTabMenuProps) {
  return (
    <Segment
      className="border rounded-3xl border-[#00C49A33] dark:border-gray-600 bg-[#F2FCFA] dark:bg-muted/50 p-1"
      classActive="bg-[#00D6A8] dark:bg-emerald-600 text-[#0A0A0A] dark:text-white rounded-3xl"
      classInactive="bg-[#F2FCFA] dark:bg-gray-700 text-[#0A0A0A] dark:text-gray-300 rounded-3xl"
      options={[
        ...(canAccessCommunityImpact
          ? [{ key: COMMUNITY_IMPACT_MAP_KEY, label: "Community Impact", icon: Store }]
          : []),
        { key: USER_DISTRIBUTIONS_MAP_KEY, label: "User Distribution", icon: Users },
        { key: LIVE_EVENTS_MAP_KEY, label: "Live Events", icon: ActivityIcon },
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
